import httpClient from '../../httpClient';

/**
 * 비밀번호 초기화 이메일 인증코드 검증
 * @typedef {Object} obj
 * @param {string} email - user email
 * @param {string} authCode - email auth Code
 */
function resetPasswordEmailAuthCode({ email, authCode }) {
  return httpClient({
    url: '/auth/password/email/verify',
    method: 'POST',
    data: {
      email,
      authCode,
    },
  });
}

export default resetPasswordEmailAuthCode;
